import { render, staticRenderFns } from "./centro-cobros.vue?vue&type=template&id=78c64cd4&scoped=true"
import script from "./centro-cobros.vue?vue&type=script&lang=js"
export * from "./centro-cobros.vue?vue&type=script&lang=js"
import style0 from "./centro-cobros.vue?vue&type=style&index=0&id=78c64cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c64cd4",
  null
  
)

export default component.exports